import { createTippy } from 'Shared/utils/lazy-tippy';
import 'Shared/tippy-legacy-theme.css';
import { mobileDetected } from 'Shared/utils/mobile-detect';

onDomReady(() => {
   if ($('badgeDetailsContent')) {
      BadgeDetails.initialize();
   } else {
      BadgeIndex.initialize();
   }
});

const BadgeDetails = {
   initialize: function () {
      $$('.viewTimesEarnedBtn').addEvent('click', ev => {
         ev.stop();
         let element = new Element('div');
         element.set('html', $('userBadgeDetailsContainer').get('html'));
         void import('Shared/modal').then(({ Modal }) => {
            Modal.open({
               type: 'element',
               element: element,
            });
         });
      });

      $('content').addEvents({
         'click:relay(.js-toggle-selected)': function (ev, el) {
            if (!mobileDetected()) {
               return;
            }

            let isSelected = el.hasClass('selected');
            $$('.js-toggle-target').hide();
            $$('.js-toggle-selected').removeClass('selected');

            let target = el.getParent().getElement('.js-toggle-target');
            if (isSelected) {
               target.hide();
               el.removeClass('selected');
            } else {
               target.show();
               el.addClass('selected');
            }
         }.bind(this),
         'click:relay(.js-filter-option)': function (ev, el) {
            if (el.hasClass('filter-option-active')) {
               $$('.js-toggle-target').hide();
               $$('.js-toggle-selected').removeClass('selected');
            }
         }.bind(this),
      });
   },
};

const BadgeIndex = {
   initialize: function () {
      this.view = App.badgeDisplayParams.view;
      this.filter = App.badgeDisplayParams.filter;

      $('content').addEvents({
         'click:relay(.js-toggle-selected)': function (ev, el) {
            if (!mobileDetected()) {
               return;
            }

            let isSelected = el.hasClass('selected');
            $$('.js-toggle-target').hide();
            $$('.js-toggle-selected').removeClass('selected');

            let target = el.getParent().getElement('.js-toggle-target');
            if (isSelected) {
               target.hide();
               el.removeClass('selected');
            } else {
               target.show();
               el.addClass('selected');
            }
         }.bind(this),
         'click:relay(.js-filter-option)': function (ev, el) {
            ev.stop();
            $$('.js-filter-option').removeClass('filter-option-active');
            el.addClass('filter-option-active');
            el.getParent('.filter-options')
               .getElement('.filterOptionNameSpan')
               .set('text', el.get('text'));

            if (mobileDetected()) {
               $$('.js-toggle-target').hide();
               $$('.js-toggle-selected').removeClass('selected');
            }
            this.setDisplayParam(el);
         }.bind(this),
         'click:relay(.badgeViewOptions .filter-option)': function (ev, el) {
            ev.stop();
            this.setDisplayParam(el);
         }.bind(this),
      });

      $$('.badgeGridContent').each(async el => {
         const parent = el.getParent('.badgeInfoBlock');
         if (!parent) return;

         const hoverContainer = parent.getElement('.badgeGridHoverContainer');
         if (!hoverContainer) return;

         const tooltipContent = hoverContainer.clone();
         tooltipContent.setStyle('display', 'block');

         await createTippy(el, {
            theme: 'globalTippyStyles',
            delay: 0,
            duration: 0,
            content: tooltipContent,
         });
      });

      window.onpopstate = this.historyStateChange.bind(this);
   },

   setDisplayParam: function (el) {
      let newView = el.get('data-view');
      let newFilter = el.get('data-filter');

      if (newView) {
         if (newView == this.view) {
            return;
         }

         this.view = newView;
      }

      if (newFilter) {
         if (newFilter == this.filter) {
            return;
         }

         this.filter = newFilter;
      }

      this.updateURI();
      this.updateDisplay();
   },

   updateDisplay: function () {
      $$('.badgeFilterControls .badgeViewOptions .filter-option').each(viewEl => {
         viewEl.toggleClass('active', viewEl.get('data-view') == this.view);
      });

      $$('.badgeView').each(el => {
         el.toggleClass('hidden', el.get('data-view') != this.view);
      });

      $$('.badgeInfoBlock').each(el => {
         let show = this.filter == 'all' || el.get('data-category') == this.filter;
         el.toggleClass('inactive', !show);
      });

      $$('.badgeFilterControls .filter-option').each(filterEl => {
         filterEl.toggleClass('filter-option-active', filterEl.get('data-filter') == this.filter);
      });
   },

   historyStateChange: function (ev) {
      let args = new URI(window.location).getData();
      this.view = args.view || App.badgeDefaultParams.view;
      this.filter = args.filter || App.badgeDefaultParams.filter;

      this.updateDisplay();
   },

   updateURI: function () {
      let invokedURI = new URI(document.location.href);
      let invokedPath = invokedURI.get('directory') + invokedURI.get('file');
      let data = {};
      if (this.view != App.badgeDefaultParams.view) {
         data.view = this.view;
      }
      if (this.filter != App.badgeDefaultParams.filter) {
         data.filter = this.filter;
      }

      let url = new URI(invokedPath).setData(data).toString();
      history.pushState(data, null, url);
   },
};
